import React, { useState, memo } from "react";

import FlexLayout from "../../components/LayoutFlex";
import { Flex, Box, Text, useMatchBreakpoints } from "@edricphan2022/uikit";

import { ArrBlockhainDev } from "./config";

import { MintContainer, BoxDetail } from "./style";

const BlockChainDev: React.FC = () => {
  const [arrBlockChain] = useState(ArrBlockhainDev);

  const { isTablet } = useMatchBreakpoints();

  return (
    <MintContainer>
      <FlexLayout flexWrap="wrap" pb="20px" alignItems="flex-start" >
        {arrBlockChain.map((_item, _index) => (
          <BoxDetail key={`blockchain-${_index}`}>
            <Flex flexDirection="column" width="100%" alignItems="flex-start" pl={["0", "0", "0", "0px"]}>
              <Flex alignItems="flex-end" pb="20px">
                <h2>
                  {_item.id}
                </h2>
                <p>
                  {_item.title.toUpperCase()}
                </p>
              </Flex>
            </Flex>
          </BoxDetail>
        ))}
      </FlexLayout>
    </MintContainer>
  );
};

export default memo(BlockChainDev);
